import { useCallback } from 'react';
import Dropdown from 'react-simple-dropdown';

export default (dropdownRef: React.RefObject<typeof Dropdown>) => {
  const hide = useCallback(() => dropdownRef.current.hide(), []);

  return {
    hide,
  };
};
